import React from "react";
import "./Header.css";
const Header = () => {
  const uaeLangImg = require("../assets/img/uae_lang.png");
  const etisalatLogo = require("../assets/img/etisalat_logo_new.png");

  return (
    <div className="header header-wrapper">
      <div className="inner-header">
        <div className="lang">
          <div className="flex-center-align">
            <div className="language-selector">
              <img src={uaeLangImg} className="language-flag" alt="" />
              <a>
                <span className="text-arabic"> عربي </span>
              </a>
            </div>
          </div>
        </div>

        <div className="logo">
          <div className="flex-center-align">
            <div className="image-wrap">
              <img className="etisalat-logo" src={etisalatLogo} />
              <h4>Urduflix</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
